import { defineRecipe } from '@chakra-ui/react/styled-system'

const baseButtonStyle = {
  borderRadius: '12px',
  color: 'var(--btn-text)',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '18px',
  letterSpacing: '-0.14px',
  padding: '16px',
  minHeight: 'auto',
  height: 'auto',
  width: '100%',
  transition: 'background-color 0.15s ease, opacity 0.15s ease',
}

export const buttonRecipe = defineRecipe({
  className: 'chakra-button',
  base: {
    ...baseButtonStyle,
    _focus: {
      boxShadow: 'none',
      outline: 'none',
    },
    _focusVisible: {
      boxShadow: '0 0 0 3px var(--brand-color-ring)',
      outline: 'none',
    },
  },
  variants: {
    variant: {
      primaryGreen: {
        bg: 'var(--brand-color)',
        color: 'var(--btn-text)',
        _hover: {
          bg: 'var(--brand-color-hover)',
          _disabled: {
            bg: 'var(--brand-color)',
            opacity: 0.35,
          },
        },
        _active: {
          bg: 'var(--brand-color-active)',
        },
        _focusVisible: {
          boxShadow: '0 0 0 3px var(--brand-color-ring)',
        },
        _disabled: {
          bg: 'var(--brand-color)',
          color: 'var(--btn-text)',
          opacity: 0.35,
          cursor: 'not-allowed',
          pointerEvents: 'none',
        },
        _loading: {
          bg: 'var(--brand-color)',
          opacity: 1,
          _hover: { bg: 'var(--brand-color)' },
        },
      },
      primaryRed: {
        bg: 'var(--brand-5ka-color)',
        color: 'var(--btn-text)',
        _hover: {
          bg: 'var(--brand-5ka-color-hover)',
          _disabled: {
            bg: 'var(--brand-5ka-color)',
            opacity: 0.35,
          },
        },
        _active: {
          bg: 'var(--brand-5ka-color-active)',
        },
        _focusVisible: {
          boxShadow: '0 0 0 3px var(--brand-5ka-color-ring)',
        },
        _disabled: {
          bg: 'var(--brand-5ka-color)',
          color: 'var(--btn-text)',
          opacity: 0.35,
          cursor: 'not-allowed',
          pointerEvents: 'none',
        },
        _loading: {
          bg: 'var(--brand-5ka-color)',
          opacity: 1,
          _hover: { bg: 'var(--brand-5ka-color)' },
        },
      },
    },
    size: {
      xs: {
        h: '8',
        minW: '8',
        px: '2.5',
        textStyle: 'xs',
      },
      sm: {
        h: '9',
        minW: '9',
        px: '3.5',
        textStyle: 'sm',
      },
      md: {
        h: '10',
        minW: '10',
        px: '4',
        textStyle: 'sm',
      },
      lg: {
        h: '11',
        minW: '11',
        px: '5',
        textStyle: 'md',
      },
    },
  },
  defaultVariants: {
    variant: 'primaryGreen',
    size: 'md',
  },
})
